import React from 'react';
import { t, Trans } from '@lingui/macro';
// eslint-disable-next-line no-restricted-imports
import { Text, Image, useBreakpoint, Group, Link, Flex } from '@landr/maestro';
import { useModalContext } from 'contexts/ModalContext/ModalContext';

const ArrowDown = () => (
    <Image
        loading="lazy"
        src={`${
            import.meta.env.BASE_URL
        }assets/keyboardCheatSheet/arrow-down.svg`}
        alt={t`Arrow down keyboard shortcuts`}
        verticalAlign="middle"
        paddingLeft="2xs"
        paddingRight="2xs"
        width="16px"
        height="16px"
        boxSizing="content-box"
        pt="none"
    />
);

const KeyboardCheatSheetInfo = () => {
    const { openModal } = useModalContext();

    const isDesktop = useBreakpoint('xxl');
    const isSmallDesktop = useBreakpoint('ml');
    const isMobile = useBreakpoint('md');

    const isConcise = isDesktop || isSmallDesktop;
    const isHidden = isSmallDesktop || isMobile;

    if (isHidden) {
        return null;
    }

    return (
        <Group gap="xs" display="flex" flexDirection="row" alignItems="center">
            <Group.Item>
                <Text color="text.medium" textStyle="body-sm">
                    ·
                </Text>
            </Group.Item>
            <Group.Item>
                <Text
                    color="text.medium"
                    textStyle="body-sm"
                    display="flex"
                    flexDirection="row"
                    text-align="center"
                    lineHeight="30px"
                    alignItems="center"
                >
                    {isConcise ? (
                        <Trans>
                            <Link
                                as="button"
                                onClick={() => openModal.keyboardCheatSheet()}
                                cursor="pointer"
                                textDecoration="underline"
                            >
                                <span>See keyboard shortcuts</span>
                            </Link>
                        </Trans>
                    ) : (
                        <Trans>
                            <span>Press </span>
                            <Flex mx="2xs">
                                <ArrowDown />
                            </Flex>
                            <span> to preview your sound. </span>
                            <Link
                                as="button"
                                onClick={() => openModal.keyboardCheatSheet()}
                                cursor="pointer"
                                textDecoration="underline"
                                marginLeft="2xs"
                            >
                                <span>See keyboard shortcuts</span>
                            </Link>
                            <span>.</span>
                        </Trans>
                    )}
                </Text>
            </Group.Item>
        </Group>
    );
};

export default KeyboardCheatSheetInfo;
